module.exports = __webpack_public_path__ + "img/30m-sprint.32bce924.png";